module.exports = __webpack_public_path__ + "img/weather55.6b026828.png";